
// 曝光数据收集
// import { log_exp } from '../config'
// polyfill
// 节流时长，默认100ms
const log_exp = 'data-exp';
import 'intersection-observer'
import maps from '../BsTrack/map'
let expMap = new maps()
let observer = null;
// 绑定监控元素
function bindExp() {
    let els = document.querySelectorAll(`[${log_exp}]`)
    for (let i = 0; i < els.length; i++) {
        let value = els[i]
        if (expMap.get(value)) continue
        expMap.set(value, true)
        observer.observe(value)
    }
}
function exp(fn) {
    IntersectionObserver.prototype['THROTTLE_TIMEOUT'] = 300
    observer = new IntersectionObserver(
        function(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // 获取指令添加时设置的元素属性
                    const args = entry.target.attributes[log_exp].value;
                    fn(args)
                }
            })
        },
        {
            root: null,
            rootMargin: '0px',
            threshold: 0 // 展示阀值  页面50%初心啊计数
        }
    );
    bindExp()
}

// export function exposure(fn) {
//     try {
//         !observer ? exp(fn) : bindExp();
//     } catch (error) {
//         console.log(error);
//     }
// }

export default {
    name: 'exp',
    init(fn){
        try {
            exp(fn);
        } catch (error) {
            console.log(error);
        }
    },
    exposure(fn) {
        try {
            !observer ? exp(fn) : bindExp();
        } catch (error) {
            console.log(error);
        }
    }
}
